export const ContratTemplate = {
    path: '/contrat_templates',
    name: 'contrat_templates',
    component: () => import('@/views/ContratTemplate/ContratTemplatePage.vue'),
    children: [

        {
            path: '/contrat_templates/add',
            name: 'contrat_templates.add',
            component: () => import('@/views/ContratTemplate/Form/ContratTemplateForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/contrat_templates/edit/:id',
            name: 'contrat_templates.edit',
            component: () => import('@/views/ContratTemplate/Form/ContratTemplateForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/contrat_templates/delete/:id',
            name: 'contrat_templates.delete',
            component: () => import('@/views/ContratTemplate/Form/ContratTemplateForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/contrat_templates/view/:id',
            name: 'contrat_templates.view',
            component: () => import('@/views/ContratTemplate/Form/ContratTemplateForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/contrat_templates/archive/:id',
            name: 'contrat_templates.archive',
            component: () => import('@/views/ContratTemplate/Form/ContratTemplateForm.vue'),
            props: {archiveAction: true}
        },
        {
            path: '/contrat_templates/unarchive/:id',
            name: 'contrat_templates.unarchive',
            component: () => import('@/views/ContratTemplate/Form/ContratTemplateForm.vue'),
            props: {unarchiveAction: true}
        },
        {
            path: '/contrat_templates/documents/:id',
            name: 'contrat_templates.documents',
            component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
            props: {module: "CONTRAT_TEMPLATE"}
        },
        {
            path: '/contrat_templates/template_applications/:id',
            name: 'contrat_templates.template_applications',
            component: () => import('@/views/Edms/TemplateApplication/ModuleTemplateApplicationPage.vue'),
            props: {module: "CONTRAT_TEMPLATE"}
        },
    ],
}
